import { render, staticRenderFns } from "./HazmatInfoModal.vue?vue&type=template&id=8064949c&scoped=true"
import script from "./HazmatInfoModal.vue?vue&type=script&lang=js"
export * from "./HazmatInfoModal.vue?vue&type=script&lang=js"
import style0 from "./HazmatInfoModal.vue?vue&type=style&index=0&id=8064949c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8064949c",
  null
  
)

export default component.exports